/* unplugin-vue-components disabled */import { render } from "./SurveyQuizPlayer.vue?vue&type=template&id=b93bb4d6&ts=true"
import script from "./SurveyQuizPlayer.vue?vue&type=script&lang=ts"
export * from "./SurveyQuizPlayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__